import application from "stimulus_application";
import TransitionController from "./transition_controller";
import "./transition.css";

application.register("transition", TransitionController);
